import { normalizeEuro } from '@amo/core/utils/normalize';
import { getTranslation } from '@amo/core/utils/index.js';
import locker from '@amo/core/assets/images/icons/locker.png';
import paiement from '@amo/core/assets/images/icons/paiement.png';
import _ from 'lodash';
import { connect } from 'react-redux';
import {
    getUrlPDFConventionAssistanceTarif,
    getUrlPDFDispositionsGeneralesTarif,
    getUrlPDFDocumentInformationTarif,
} from '../../../../../../redux/selectors/tarif/tarif.selectors';

const SubscribeSection = (props) => {
    const {
        formuleChoisie,
        data,
        changeValue,
        postFill,
        codePromo,
        prixTotalMensuel,
        prixTotalMensuelPromo,
        prixTotalAnnuel,
        prixTotalAnnuelPromo,
        fractionnementChoisi,
        nbOptions,
        options,
        loadingFill,
        loadingCodePromo,
        formuleCodePromoEligible,
        formuleMessageEligibleCodePromo,
        analyticsSetEvent,
        urlDocumentInformation,
        urlDispositionsGenerales,
        urlAnnexeAssistance,
    } = props;

    const optionsChoisi = _.get(data, 'options');
    const optionsListe = _.get(data, 'optionsListe');
    const optionsFranchise = _.get(data, 'optionsFranchise');

    const selectedOptionNames = [];
    if (optionsChoisi) {
        _.forEach(optionsChoisi, (value, key) => {
            if (value) {
                const group = _.find(options, ['idGroupe', key]);
                if (group?.labelGroupe) {
                    selectedOptionNames.push(group.labelGroupe);
                }
            }
        });
    }
    if (optionsListe) {
        _.forEach(optionsListe, (value, key) => {
            if (value) {
                const group = _.find(options, ['idGroupe', key]);
                if (group?.labelGroupe) {
                    selectedOptionNames.push(group.labelGroupe);
                }
            }
        });
    }
    if (optionsFranchise) {
        _.forEach(optionsFranchise, (value, key) => {
            if (value === 'true') {
                const name = key === 'RAFRAVI' ? 'Rachat franchise vol/incendie' : key === 'RAFRADTA' ? 'Rachat franchise tous accidents' : key;
                selectedOptionNames.push(name);
            }
        });
    }

    const isMensuel = fractionnementChoisi === 'M';
    const prix = isMensuel ? prixTotalMensuelPromo : prixTotalAnnuelPromo;
    const prixSansPromo = isMensuel ? prixTotalMensuel : prixTotalAnnuel;
    const hasPromo = codePromo?.Eligible && prixSansPromo && prix < prixSansPromo;

    const validateStepTarif = (type) => {
        changeValue('typeDevis', type);
        postFill({ getTarif: false });
    };

    return (
        <div id="souscrire" style={{ textAlign: 'left' }}>
            {/* Price summary */}
            <div className="bottom-price-bar">
                <div className="bpb-detail">
                    <div className="bpb-formule">
                        Formule {formuleChoisie?.LibelleFormule}
                        {nbOptions >= 1 && ` + ${nbOptions} option${nbOptions > 1 ? 's' : ''}`}
                    </div>
                    {selectedOptionNames.length > 0 && <div className="bpb-options">{selectedOptionNames.join(', ')}</div>}
                </div>
                <div style={{ textAlign: 'right' }}>
                    <div className="bpb-price">{normalizeEuro(prix)}</div>
                    {hasPromo && <div className="bpb-price-old">{normalizeEuro(prixSansPromo)}</div>}
                    <div className="bpb-period">
                        TTC / {isMensuel ? getTranslation('months') : getTranslation('year')}
                        {isMensuel && (
                            <span className="bpb-annual">
                                {' '}
                                soit {normalizeEuro(Math.round(prix * 12 * 100) / 100)} TTC/{getTranslation('year')}
                            </span>
                        )}
                    </div>
                </div>
            </div>

            {/* Promo code */}
            <div className="promo-section-op">
                <label className="promo-label-op" htmlFor="promo-code-input">
                    🎁&ensp; Vous avez un code promo ?
                </label>
                <div className="promo-row-op">
                    <div className="promo-input-group">
                        <input
                            id="promo-code-input"
                            className="promo-input-op"
                            type="text"
                            placeholder="Saisir votre code"
                            value={_.get(data, 'DemandeTarif[CodePromo][CodePromo]') || ''}
                            onChange={(e) => changeValue('DemandeTarif[CodePromo][CodePromo]', e.target.value)}
                        />
                        <button className="btn btn-outline-primary fw-normal py-1 px-3 f-12 btn-valider-op" onClick={() => postFill({ codePromo: true })}>
                            {loadingCodePromo ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : getTranslation('validate')}
                        </button>
                    </div>
                    {!loadingFill && (
                        <div className="promo-btns-group">
                            <button className="btn-souscrire-op" onClick={() => validateStepTarif('subscribe')} data-cy="subscribe-button">
                                {getTranslation('subscribe')}
                            </button>
                            <button className="btn-email-op" onClick={() => validateStepTarif('devis')}>
                                {getTranslation('pricing.subscribe.receiveProposalByEmail')}
                            </button>
                        </div>
                    )}
                    {loadingFill && <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />}
                </div>
                {codePromo && !formuleCodePromoEligible && formuleMessageEligibleCodePromo && <p className="text-danger f-14 mt-2">{getTranslation('pricing.promoCode.error')}</p>}
                {codePromo?.Eligible && formuleCodePromoEligible && formuleMessageEligibleCodePromo && <p className="text-success f-14 mt-2">{getTranslation('pricing.promoCode.success')}</p>}
            </div>

            {/* Secure badge */}
            <div className="action-btns-op">
                <div className="secure-badge-op">
                    <img src={locker} alt="" aria-hidden="true" loading="lazy" />
                    {getTranslation('footer.securePayment')}
                    <img src={paiement} alt="Cartes bancaires acceptées : Mastercard et Visa" width={88} height={27} loading="lazy" />
                </div>
            </div>

            {urlDocumentInformation && (
                <p className="f-12 mt-2 text-center">
                    <a href={urlDocumentInformation} target="_blank" rel="noopener noreferrer">
                        Veuillez trouver ci-joint le document d’information sur le produit d’assurance proposé.
                    </a>
                </p>
            )}

            {urlDispositionsGenerales && (
                <p className="f-12 mt-1 mb-0 text-center">
                    <a href={urlDispositionsGenerales} target="_blank" rel="noopener noreferrer">
                        * Voir les Dispositions Générales
                        <span className="visually-hidden"> (nouvelle fenêtre)</span>
                    </a>
                </p>
            )}

            {urlAnnexeAssistance && (
                <p className="f-12 mt-1 mb-0 text-center">
                    <a href={urlAnnexeAssistance} target="_blank" rel="noopener noreferrer">
                        ** Voir l’Annexe Assistance
                        <span className="visually-hidden"> (nouvelle fenêtre)</span>
                    </a>
                </p>
            )}
        </div>
    );
};

const mapStateToProps = (state) => ({
    urlDocumentInformation: getUrlPDFDocumentInformationTarif(state),
    urlDispositionsGenerales: getUrlPDFDispositionsGeneralesTarif(state),
    urlAnnexeAssistance: getUrlPDFConventionAssistanceTarif(state),
});

export default connect(mapStateToProps)(SubscribeSection);
